import axiosInstance from './api'

export const purchaseCoins = async (coins, billingData, couponCode = null, paymentMethod = 'paypal') => {
  const response = await axiosInstance.post('/billing/coins/purchase', {
    coins,
    billingData,
    couponCode,
    paymentMethod
  })
  return response.data
}

export const calculatePrice = async (coins) => {
  const response = await axiosInstance.post('/billing/calculate-price', {
    coins
  })
  return response.data
}

export const getBillingHistory = async (page = 1, limit = 10) => {
  const response = await axiosInstance.get('/billing/history', {
    params: { page, limit }
  })
  return response.data
}

export const downloadInvoice = async (billingId) => {
  const response = await axiosInstance.get(`/billing/invoice/${billingId}`, {
    responseType: 'blob'
  })
  return response
}


export const confirmPayPalPayment = async (billingId, orderId, payerId) => {
  const response = await axiosInstance.post('/billing/paypal/confirm', {
    billingId,
    orderId,
    payerId
  })
  return response.data
}

export const recheckPayPalPayment = async (billingId) => {
  const response = await axiosInstance.post(`/billing/paypal/recheck/${billingId}`)
  return response.data
}

export const getPayPalRedirectUrl = async (billingId) => {
  const response = await axiosInstance.get(`/billing/paypal/redirect/${billingId}`)
  return response.data
} 